// extracted by mini-css-extract-plugin
export default {"resumePage":"Resume_resumePage__OJEWv","resumeDocument":"Resume_resumeDocument__Ddt8d","printResumeDocument":"Resume_printResumeDocument__6fk6L"};